import type { Selected } from './index.h'

export const isSameSelected =
  (a?: Selected | null) => (b?: Selected | null) => {
    if (a == null || b == null) return false
    return a.channelId === b.channelId && a.programId === b.programId
  }
